import { onBeforeUnmount, onMounted, ref } from 'vue'

/**
 * The screen's side safe-area insets in pixels, for what sizes itself in script: a Vuetify layout
 * item takes its width as a number, and `env()` is CSS only. With `viewport-fit=cover` an iPhone in
 * landscape puts its notch over one side, so a drawer fixed to that edge widens by it and pads its
 * content (docs/plans/mobile-navigation.md, MN4); everywhere else both are 0.
 *
 * Read from a hidden element that pads itself with `env()`, and again on every resize, which a
 * rotation is.
 */
export function useSafeAreaInsets() {
  const left = ref(0)
  const right = ref(0)
  let probe: HTMLElement | null = null

  function read() {
    if (!probe) return
    const style = getComputedStyle(probe)
    left.value = parseFloat(style.paddingLeft) || 0
    right.value = parseFloat(style.paddingRight) || 0
  }

  onMounted(() => {
    probe = document.createElement('div')
    probe.setAttribute('aria-hidden', 'true')
    probe.style.cssText =
      'position:fixed;top:0;left:0;visibility:hidden;pointer-events:none;' +
      'padding-left:env(safe-area-inset-left,0px);padding-right:env(safe-area-inset-right,0px)'
    document.body.appendChild(probe)
    read()
    window.addEventListener('resize', read)
  })

  onBeforeUnmount(() => {
    window.removeEventListener('resize', read)
    probe?.remove()
    probe = null
  })

  return { left, right }
}
